export default __webpack_public_path__ + "static/media/bedroom3.360f59c8.mp3";